exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vue-affix {\n    position: fixed;\n  }", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-5035b9c4&file=Affix.vue!./~/vue-loader/lib/selector.js?type=style&index=0!./src/Affix.vue
 ** module id = 82
 ** module chunks = 0
 **/